import {
    FETCH_ETAPAS, FETCH_OPERADORES,
    FETCH_PRODUCTION_STATISTICS_BY_STATION, RECEIVE_ETAPAS, RECEIVE_OPERADORES,
    RECEIVE_PRODUCTION_STATISTICS_BY_STATION
} from "../actions/actionTypes";
import dataObjectFromFile from "../assets/mock/1/state0.json";

const initialState = () => {


    const at = localStorage.getItem('accessToken');
    if (at && at == "mock") {
        return {
            ...dataObjectFromFile.tires
        }
    }


    return {
        isFetchingProductionStatisticsByStation: false,
        ProductionStatisticsByStation: [],
        etapas: [],
        operadores: []
    }
}



export default (state = initialState(), action) => {
    switch(action.type) {
        case FETCH_PRODUCTION_STATISTICS_BY_STATION:
            return {
                ...state,
                isFetchingProductionStatisticsByStation: true,
                ProductionStatisticsByStation: []
            }
        case RECEIVE_PRODUCTION_STATISTICS_BY_STATION:
            return {
                ...state,
                isFetchingProductionStatisticsByStation: false,
                ProductionStatisticsByStation: action.payload.data
            }
        case FETCH_ETAPAS:
            return {
                ...state,
                etapas: []
            }
        case RECEIVE_ETAPAS:
            return {
                ...state,
                etapas: action.payload.data
            }

        case FETCH_OPERADORES:
            return {
                ...state,
                operadores: []
            }
        case RECEIVE_OPERADORES:
            return {
                ...state,
                operadores: action.payload.data
            }

        default:
            return state;
    }
}
